import React, { useState } from 'react';
import { FiPlus, FiList } from 'react-icons/fi';
import AddAnswer from './AddAnswer'; // Votre composant pour ajouter une réponse
import ListAnswers from './ListAnswers'; // Votre composant pour lister les réponses

const Answers: React.FC = () => {
  const [activeView, setActiveView] = useState<'list' | 'add' | 'edit'>('list');
  const [answerToEdit, setAnswerToEdit] = useState<number | null>(null);

  // Function to handle editing an answer
  const handleEditAnswer = (answerId: number) => {
    setAnswerToEdit(answerId);
    setActiveView('edit');
  };

  return (
    <div>
      <div className="mb-8">
        <h2 className="text-2xl font-bold text-gray-800">Gestione delle Risposte</h2> {/* Affichage en italien : Gestion des Réponses */}

        <div className="mt-4 flex gap-2">
          <button
            onClick={() => setActiveView('list')}
            className={`px-4 py-2 rounded-lg text-sm font-medium flex items-center gap-2
            ${activeView === 'list'
              ? 'bg-indigo-500 text-white'
              : 'bg-white text-gray-600 hover:bg-gray-50'
            }`}
          >
            <FiList />
            Lista {/* Affichage en italien : Liste */}
          </button>
          <button
            onClick={() => setActiveView('add')}
            className={`px-4 py-2 rounded-lg text-sm font-medium flex items-center gap-2
            ${activeView === 'add'
              ? 'bg-indigo-500 text-white'
              : 'bg-white text-gray-600 hover:bg-gray-50'
            }`}
          >
            <FiPlus />
            Aggiungere {/* Affichage en italien : Ajouter */}
          </button>
        </div>
      </div>

      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
        {activeView === 'list' && <ListAnswers onEditAnswer={handleEditAnswer} />} {/* Liste des réponses */}
        {activeView === 'add' && <AddAnswer setActiveView={setActiveView} />} {/* Ajouter une réponse */}
        {activeView === 'edit' && answerToEdit !== null && (
          <AddAnswer setActiveView={setActiveView} answerId={answerToEdit} /> // Mise à jour d'une réponse
        )}
      </div>
    </div>
  );
};

export default Answers;
